export default "__VITE_ASSET__DjRc2e5C__"